import styled from 'styled-components';

export const InfoToolTipWrapper = styled.div`
  display: flex;
  align-items: center;
  font-family: ${(props) => props.theme.font.family};
`;
